import { atom } from 'jotai'

export const foodAtom = atom([])